import React from "react";
import { Link } from "gatsby";
import { connect } from "react-redux";
import styled from "@emotion/styled";
import {
  shortnameSelector,
  isLoggedIn,
  getAuthUser
} from "modules/session/selectors";
import {
  getMyProfile,
  getBraceletColor,
  getBraceletName,
  getMissions
} from "modules/playground/selectors";
import { loadMyProfile, loadMissions } from "modules/playground/action";

// refactor
import PlaygroundActions from "components/PlaygroundActions";
import PlaygroundPoints from "components/PlaygroundPoints";
import LeaderboardCard from "components/LeaderboardCard";
import HowToPlayCard from "components/HowToPlayCard";
import MapOfPlayground from "components/MapOfPlayground";
import LostYourBraceletCard from "components/LostYourBraceletCard";
import ExhibitorCard from "components/ExhibitorCard";
import MissionCard from "components/MissionCard";
import RoundButton from "components/RoundButton";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

function DashboardPlayground(props) {
  React.useEffect(() => {
    if (props.isLoggedIn) {
      props.loadMyProfile();
      props.loadMissions();
    }
  }, []);

  const points = props.myProfile ? props.myProfile.points : 0;
  const braceletColor = props.myProfile ? props.braceletColor : "";
  const braceletName = props.myProfile ? props.braceletName : "";
  const missions = props.missions ? props.missions : [];
  const completedMissions = missions.filter(missions => missions.is_done);
  const standings = props.myProfile ? props.myProfile.rank : 0;

  return (
    <Container>
      <PlaygroundPoints points={points} />
      <PlaygroundActions />
      <LeaderboardCard playerRank={standings} />
      <div>
        <MissionCard
          braceletColor={braceletColor}
          braceletName={braceletName}
          missions={missions.length}
          completedMissions={completedMissions.length}
        />
        <Link to="/how-to-play">
          <HowToPlayCard />
        </Link>
        <a href="https://drive.google.com/file/d/10jQEHshnWzbm6y95fAZKvR-JVbBzRAJM/view">
          <MapOfPlayground />
        </a>
        <a href="https://forms.gle/T3YnznaN9KnLV4v47">
          <ExhibitorCard />
        </a>
        <Link to="/welcome">
          <LostYourBraceletCard />
        </Link>
      </div>

      <Link css={{ alignSelf: "center" }} to="/">
        <RoundButton
          css={{
            width: "278px",
            marginTop: "10px",
            marginBottom: "10px"
          }}
        >
          Go to Main Website
        </RoundButton>
      </Link>
      <Link css={{ alignSelf: "center" }} to="/dashboard/logout">
        <RoundButton
          css={{ width: "278px", color: "black", background: "white" }}
        >
          Logout
        </RoundButton>
      </Link>
    </Container>
  );
}

const withConnect = connect(
  state => ({
    name: shortnameSelector(state),
    isLoggedIn: isLoggedIn(state),
    user: getAuthUser(state),
    myProfile: getMyProfile(state),
    braceletColor: getBraceletColor(state),
    braceletName: getBraceletName(state),
    missions: getMissions(state)
  }),
  { loadMyProfile, loadMissions }
);

export default withConnect(DashboardPlayground);
